import React, { Component } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import {Button} from "reactstrap";
import {connect} from "react-redux";
import {setCropData, toggleLoading, setCroppedFaceImage, setTourStep, closeTour} from "../../actions";
import ContainerDimensions from "react-container-dimensions";
import Tour from "reactour";
import ReactCrop from "../ReactCrop";

class FaceCropper extends Component {
  imageRef = null;

  state = {
    shouldTourClosed: false
  };

  timer = null;

  constructor(props) {
    super(props);
    this.handleCropChange = this.handleCropChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  componentDidMount() {
    this.props.setTourStep(1);
    // window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {

    }, 200);
  }

  handleCropChange(newCrop) {
    const fixedCrop = {
      unit: '%',
      x: newCrop.x / this.imageRef.width * 100,
      y: newCrop.y / this.imageRef.height * 100,
      width: newCrop.width / this.imageRef.width * 100,
      height: newCrop.height / this.imageRef.height * 100
    };
    // this.setState({crop: newCrop});
    this.props.setCropData(fixedCrop);
    //this.props.closeTour(1);
  }

  getCroppedImg(image, crop, fileName) {
    console.log(crop);
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = image.width * (crop.width / 100) * scaleX;
    canvas.height = image.height * (crop.height / 100) * scaleY;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      (crop.x / 100) * image.width * scaleX,
      (crop.y / 100) * image.height * scaleY,
      (crop.width / 100)* image.width * scaleX,
      (crop.height / 100) * image.height * scaleY,
      0,
      0,
      (crop.width / 100) * image.width * scaleX,
      (crop.height / 100) * image.height * scaleY,
    );

    // As Base64 string
    // const base64Image = canvas.toDataURL('image/jpeg');

    // As a blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        blob.name = fileName;
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.onload = function() {
          resolve({src: reader.result, width: (crop.width / 100) * image.width, height: (crop.height / 100) * image.height});
        };

      }, 'image/png');
    });
  }

  handleNext() {
    this.props.toggleLoading(true);
    this.getCroppedImg(this.imageRef, this.props.meishi.cropData, 'face.jpg').then(result => {
      this.props.setCroppedFaceImage(result.src, result.width, result.height);
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="t-content-right-toolbar">
          <div className="actions">
            <Button color="info" onClick={this.handleNext} className={!this.props.meishi.tour[1] ? 'blinking' : ''}>次へ: 顎ラインのトリミング</Button>
          </div>
          <div>顔の部分を選択してください</div>
        </div>
        <div className="t-content-right-bottom-area">
          <ContainerDimensions>
            {({width, height}) => {
              const image = this.props.image;
              const containerRatio = width / height;
              const imageRatio = image.width / image.height;

              // let ratio = 1.0;
              let className = '';
              let imageStyle = {};

              if (imageRatio > containerRatio) {
                className = 'landscape';
                // ratio = width / image.width;
                imageStyle.width = width - 20;
              } else {
                className = 'portrait';
                // ratio = height / image.height;
                imageStyle.height = height -20;
              }

              return (
                <div className="t-content-crop-area">
                  <ReactCrop
                    src={this.props.image.src}
                    crop={this.props.meishi.cropData}
                    onChange={newCrop => this.handleCropChange(newCrop)}
                    onComplete={() => {
                      if (this.state.shouldTourClosed) {
                        this.props.closeTour(1);
                      }
                      this.setState({shouldTourClosed: true});
                    }}
                    onImageLoaded={imageRef => { this.imageRef = imageRef; }}
                    crossorigin="anonymous"
                    className={className}
                    imageStyle={imageStyle}
                    keepSelection={true}
                  />
                </div>
              );
            }}
          </ContainerDimensions>
        </div>
        {/*<Tour*/}
        {/*  steps={*/}
        {/*    [{*/}
        {/*      selector: '.t-content-crop-area',*/}
        {/*      content: () => (*/}
        {/*        <div>*/}
        {/*          <p>顔の部分を範囲選択してください。</p>*/}
        {/*          <img src={window.tProjectGlobals.assetBaseUrl + "img/tour-pic1.png"} alt="" width="200"/>*/}
        {/*        </div>*/}
        {/*      ),*/}
        {/*    }]*/}
        {/*  }*/}
        {/*  isOpen={this.props.meishi.tour[1]}*/}
        {/*  onRequestClose={() => { this.props.closeTour(1) }}*/}
        {/*  showNumber={false}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }
}

export default connect(f => f, {setCroppedFaceImage, toggleLoading, setTourStep, setCropData, closeTour})(FaceCropper);


// WEBPACK FOOTER //
// ./src/components/Face/FaceCropper.js